import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Card.css";

const Card = ({ data, onViewProfile, onSponsor }) => {
  let {
    avatar_url,
    name,
    total_expenses,
    join_date,
    address,
    category_name,
    category_color,
    id,
    to_be_sponsor,
    date_of_birth,
    categories,
    state
  } = data;

  // Helper: get all categories as array
  let categoryList = [];
  if (Array.isArray(data.categories) && data.categories.length > 0) {
    categoryList = data.categories.map(cat => cat.category_name || cat.name || cat);
  } else if (category_name) {
    categoryList = [category_name];
  }

  // Age calculation - current year minus birth year
  let age = '';
  if (date_of_birth) {
    const birthYear = new Date(date_of_birth).getFullYear();
    const currentYear = new Date().getFullYear();
    age = `${currentYear - birthYear}Y`;
  }

  // Truncate name to max 10 characters, add dot if longer
  const displayName = name && name.length > 10 ? name.slice(0, 10) + '.' : name;

  const getCategoryBackgroundColor = (categoryName) => {
    if (!categoryName) return "#D3B1FF";
    const category = categoryName.toLowerCase();
    if (category === 'hafiz') return '#a4b465';
    if (category === 'communal violence') return '#fca470';
     if (category === 'orphans') return '#94b088';
     if (category === 'mob lynching') return '#e27878';
     if (category === 'police atrocity') return '#F6EFBD';
     if (category === 'impoverish') return '#bd90a9';
     if (category === 'demolition') return '#96b1ab';
     if (category === 'refugees') return '#bda887';
     if (category === 'disaster') return '#ABE0F0';
    return '#bda887';
  };


  const bgColor = getCategoryBackgroundColor(categoryList[0]);

  return (
    <div
      style={{
        background: bgColor,
          borderRadius: "30px",
          boxShadow: "0 5px 15px rgba(0,0,0,0.07)",
          padding: 0,
          width: 279,
          minHeight: 452,
          height: 452,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          justifyContent: "flex-end",
          overflow: "hidden",
          transition: "none",
          WebkitTapHighlightColor: "transparent",
          touchAction: "pan-y",
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
      }}
      className="sponsored-card"
    >
      {/* Image area */}
      <div
        style={{
          width: "100%",
          height: 255,
          background: data.avatar_url ? "none" : "#e6f5e6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          position: "absolute",
          top: 0,
          left: 0,
          pointerEvents: "none",
        }}
      >
        <img
          src={avatar_url || "./child/noImg.png"}
          alt={name}
          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 0 }}
        />
      </div>

      {/* Card content at the bottom */}
      <div
        style={{
          width: "100%",
          padding: "0rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-end",
        marginTop: 256,
          height: "176px",
          pointerEvents: "none",        }}
      >
        {/* Name */}
        <div
          style={{
            fontWeight: 550,
            fontSize: 28,
            color: "#293E4F",
            marginTop: 0,
            marginBottom: 20,
            textAlign: "left",
            fontFamily: "Poppins",
            width: "100%",
            lineHeight: 1.1,
            alignItems: "center",
            textAlign: "center",
            justifyContent: "center",
            width: "100%",
            pointerEvents: "none",
          }}
        >
          {displayName}
          &nbsp;
          <span style={{fontSize: 14, color: '#293E4F', fontWeight: '300'}}>
            {age && <span>{age}</span>}
            {age && state && <span style={{ margin: '0 2px', fontSize: 10 }}>, </span>}
            {state && <span>{state}</span>}
          </span>
        </div>

        {/* Category badge */}
        <div
          style={{
            background: "rgba(255, 255, 255, 0.3)",
            color: "#333",
            fontSize: 12,
            fontWeight: 600,
            fontFamily: "Inter",
            borderRadius: 24,
            padding: "4px 18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "fit-content",
            margin: "0 auto 10px auto",
            minHeight: 20,
            boxSizing: "border-box",
            letterSpacing: 0.2,
            pointerEvents: "none",
          }}
        >
          {category_name}
        </div>

        {/* Monthly Expenses */}
        <p style={{
           color: "#293E4F",
           fontSize: "12px",
           fontWeight: "600",
           display: "flex",
           alignItems: "center",
           width: "100%",
           justifyContent: "center",
           fontFamily: "Inter",
           margin: "4px auto 12px auto",
           pointerEvents: "none",
        }}>
          Monthly Expenses: ₹{total_expenses}
        </p>

        {/* View Profile Button */}
        <button
          style={{
            background: "#293e4f",
            border: "none",
            borderRadius: "40px",
            padding: "8px 4px",
            color: "#fdc512",
            fontWeight: 300,
            fontSize: 16,
            width: "70%",
            margin: "0px auto",
            marginBottom: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            cursor: "pointer",
            transition: "background 0.2s",
            pointerEvents: "auto",
            fontFamily: "Inter", 
          }}
          onClick={() => onSponsor(id)}
        >
          Sponsor
        </button>

        {/* Expiring On Link */}
        <a 
          style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              textDecoration: "underline",
              fontSize: "12px",
marginBottom: "10px",
              fontWeight: "400",
              color: "#293E4F",
              pointerEvents: "auto",
          }}
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onViewProfile(id);
          }}
        >
          View Profile
        </a>
      </div>
    </div>
  );
};

export default Card;